export default __webpack_public_path__ + "static/media/mainImage.25058c97.jpg";